@if (isLoadingResults) {
  <div class="example-loading-shade">
    <mat-spinner [style.zoom]="1"></mat-spinner>
  </div>
}
<div [formGroup]="SettingForm" class="one" fxLayout="column">
  <div class="main-div">
    <button
      mat-flat-button=""
      color="accent"
      class="top-botton spend-money-button btn-text mat-focus-indicator mat-accent mat-raised-button mat-button-base activities-buttons fs-14 top-0 mr-0"
      (click)="getValue()"
    >
      <mat-icon class="fs-21">add</mat-icon>
      Add
    </button>
  </div>

  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-card
      appearance="outlined"
      class="table-width"
      [ngClass]="class == true ? 'table_height-526' : 'table_height-525'"
    >
      <div class="customer table-div">
        @if (user_partner_distribution_rate?.length == 0) {
          <div class="grid-overlay">
            <div class="grid-overlay-msg display">There is no data to display.</div>
          </div>
        }
        <table
          mat-table
          [dataSource]="getDataForTable"
          (matSortChange)="sortDataval($event)"
          matSort
          class="simple transparent-sticky-table"
          multiTemplateDataRows
          matSortActive="{{ sortactive }}"
          matSortDirection="{{ sortDirection }}"
        >
          <ng-container matColumnDef="EFFECTIVEFROMAMOUNT" sticky>
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Effective From</th>
            <td mat-cell *matCellDef="let element">
              {{ element.EFFECTIVEFROMAMOUNT | toFixedAmount: 1 }}
            </td>
          </ng-container>
          <ng-container matColumnDef="DISTRIBUTIONPERCENT" sticky>
            <th mat-header-cell *matHeaderCellDef>Percent</th>
            <td style="padding: 0px 8px" mat-cell *matCellDef="let element">
              {{ element.DISTRIBUTIONPERCENT }}
            </td>
          </ng-container>
          <ng-container matColumnDef="Action" sticky>
            <th
              mat-header-cell
              *matHeaderCellDef
              style="text-align: center; padding-right: 25px; width: 80px"
            ></th>
            <td
              mat-cell
              *matCellDef="let element"
              style="text-align: center; padding: 0px 10px; width: 80px"
            >
              <div class="ng-tns-c142-6">
                <button
                  matIconButton
                  (click)="toggleRow(element)"
                  class="spend-money-dropdown flex items-center border border-black/12 text-black"
                >
                  <mat-icon class="items-center justify-center text-2xl">
                    {{ element.expanded ? 'keyboard_arrow_down' : 'edit' }}
                  </mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="header-row-first-group">
            <td mat-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length" class="!p-4">
              <div class="flex w-full items-center gap-3">
                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Effective From</mat-label>
                  <input
                    #effFromRef
                    formControlName="EFFECTIVEFROMAMOUNT"
                    matInput
                    appCurrencyFormat
                  />
                </mat-form-field>

                <mat-form-field appearance="outline" class="flex-1">
                  <mat-label>Percent</mat-label>
                  <input formControlName="DISTRIBUTIONPERCENT" type="number" matInput />
                </mat-form-field>

                <button
                  mat-raised-button
                  color="accent"
                  class="!rounded-full !bg-green-600 px-6 !text-white"
                  (click)="finalSave('save')"
                >
                  Save
                </button>

                <button
                  mat-button
                  class="rounded-full! text-red-500!"
                  (click)="maintainFlag = false"
                >
                  Cancel
                </button>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="expandedDetail">
            <td
              mat-cell
              *matCellDef="let element"
              [attr.colspan]="displayedColumns.length"
              style="padding: 0px 8px"
            >
              <div
                class="example-element-detail"
                animate.enter="detail-expand-in"
                animate.leave="detail-expand-out"
              >
                <div fxLayout="row" fxLayoutAlign="start center" class="py-4">
                  <mat-form-field
                    appearance="outline"
                    class="example pr-1"
                    fxFlex="49"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Effective From</mat-label>
                    <input
                      #effFromEditRef
                      formControlName="EFFECTIVEFROMAMOUNT"
                      type="text"
                      name="EFFECTIVEFROMAMOUNT"
                      placeholder="Effective From"
                      matInput
                      appCurrencyFormat
                      style="text-align: right"
                    />
                  </mat-form-field>
                  <mat-form-field
                    appearance="outline"
                    fxFlex="50"
                    class="pr-1"
                    subscriptSizing="dynamic"
                  >
                    <mat-label>Percent</mat-label>
                    <input
                      formControlName="DISTRIBUTIONPERCENT"
                      type="number"
                      [disabled]="secondData"
                      name="DISTRIBUTIONPERCENT"
                      placeholder="Percent"
                      matInput
                    />
                  </mat-form-field>
                </div>
                <mat-dialog-actions class="popup_ftr justify-end! gap-0!">
                  @if (ShowDuplicateBotton == false) {
                    <button
                      (click)="finalSave('save')"
                      fxFlex="20"
                      style="padding-left: 10px !important"
                      class="ng-tns-c142-6 mdc-button mdc-button--unelevated mat-mdc-unelevated-button mat-primary spend-money-updates mat-mdc-button-base"
                      mat-raised-button
                      color="accent"
                      cdkFocusInitial
                    >
                      Update
                    </button>
                  }
                  @if (ShowDuplicateBotton == false) {
                    <button
                      fxFlex="20"
                      class="btn-add-2 rounded-full! pr-1 text-red-500!"
                      mat-button
                      (click)="deleteItem()"
                      cdkFocusInitial
                    >
                      Delete
                    </button>
                  }
                  @if (ShowDuplicateBotton == true) {
                    <button
                      (click)="CollapstExpandedrow()"
                      mat-button
                      color="warn"
                      class="activity-drop-button btn-red"
                    >
                      Cancel
                    </button>
                  }
                </mat-dialog-actions>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr
            class="mat-header-row-r"
            mat-header-row
            *matHeaderRowDef="['header-row-first-group']"
            [ngClass]="maintainFlag ? 'displyRowflex' : 'hideRow'"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="rowclick(row); highlightedRows = row.USERPARTNERDISTRIBUTIONRATEGUID"
            [style.background]="
              highlightedRows == row.USERPARTNERDISTRIBUTIONRATEGUID ? selectedColore : ''
            "
            [ngClass]="
              highlightedRows == row.USERPARTNERDISTRIBUTIONRATEGUID ? 'row-text-colore' : ''
            "
            class="example-element-row"
            [class.example-expanded-row]="row.expanded"
          ></tr>

          <tr
            mat-row
            *matRowDef="let row; columns: ['expandedDetail']; when: isExpandedRow"
            class="example-detail-row"
          ></tr>
        </table>
      </div>
    </mat-card>
  </div>
</div>
